import { Navigate } from 'react-router-dom';
import { detectLocale } from '@/client/i18n';

export function RootRedirect() {
  const locale = detectLocale();
  return <Navigate to={`/${locale}/`} replace />;
}
